import { HugeiconsIcon as BaseHugeiconsIcon } from "@hugeicons/react"

/**
 * Decorative by default. Icon-only controls must name the containing button
 * with aria-label; genuinely informative icons can opt in with aria-label.
 */
export function HugeiconsIcon({ "aria-label": ariaLabel, ...props }) {
  return (
    <BaseHugeiconsIcon
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      role={ariaLabel ? "img" : undefined}
      {...props}
    />
  )
}
